import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import SettingApi from '../server/SettingApi';

export default {

    getAll: () => {
        const types = {
            success:    ActionTypes.SETTING_LIST_SUCCESS,
            failure:    ActionTypes.SETTING_LIST_FAILURE
        };
        return CentricDispatcher.dispatchAsync(SettingApi.getAll(), types);
    },

    save: (setting, original = null) => {
        const types = {
            request:    ActionTypes.SETTING_SAVE_REQUEST,
            success:    [ActionTypes.SETTING_SAVE_SUCCESS, ActionTypes.FORM_SUBMIT_SUCCESS],
            failure:    ActionTypes.FORM_SUBMIT_ERROR
        };
        return CentricDispatcher.dispatchAsync(SettingApi.save(setting), types, {setting, original});
    }
};
